<template>
  <div class="intermediaryPlatformOrder">
    <el-menu class="menu" :default-active="activeIndex" mode="horizontal" @select="menuSelect">
      <el-menu-item index="1">美团团购商品映射</el-menu-item>
      <el-menu-item index="2">美团订单核销记录</el-menu-item>
    </el-menu>
    <div class="content">
      <component :is="componentMap[activeIndex]" />
    </div>
  </div>
</template>

<script>
  import MeituanProductMapping from './components/MeituanProductMapping.vue'
  import MeituanVerificationRecord from './components/MeituanVerificationRecord.vue'
  export default {
    name: 'intermediaryPlatformOrder',
    components: {
      MeituanProductMapping,
      MeituanVerificationRecord
    },
    data() {
      return {
        componentMap: {
          "1": MeituanProductMapping,
          "2": MeituanVerificationRecord
        },
        activeIndex: "1"
      }
    },
    methods: {
      menuSelect(key) {
        this.activeIndex = key;
      }
    }
  }
</script>

<style lang="less" scoped>
  .intermediaryPlatformOrder {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
  }

  .menu {
    flex-shrink: 0;
    width: 100%;
  }

  .content {
    flex-grow: 1;
    width: 100%;
    min-height: 0px;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>